import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Member/api/APIEndpoints';
import { setBearerToken } from 'src/redux/app/userSlice';

const useAccountUnlockVerifyLink = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const headingRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [OTPRequired, setOTPRequired] = useState(false);
  const [forcePassword, setForcePassword] = useState(false);

  const verifyLink = async () => {
    try {
      const response = await axiosInstance.get(
        `${APIEndpoints.getSelfAccountLinkVerification()}/id/${slug}`,
      );
      const OTPRequired = response?.data?.Response?.OtpRequired;
      const forcePassword = response?.data?.Response?.ResetPassword;
      if (OTPRequired) {
        setToken(response?.data?.Response);
        if (forcePassword) {
          navigate('/member/account-unlock-otp', {
            state: {
              data: response?.data?.Response,
              isForcePassword: true,
            },
          });
          //both true
        } else {
          //only OTPRequired
          navigate('/member/account-unlock-otp', {
            state: {
              data: response?.data?.Response,
              isForcePassword: false,
            },
          });
        }
      } else {
        if (forcePassword) {
          setToken(response?.data?.Response);
          navigate('/member/account-unlock-reset-password', {
            state: {
              data: response?.data?.Response,
            },
          });
          //only forcePassword
        } else {
          setToken(response?.data?.Response);
          navigate('/member/account-unlock-success', {
            state: {
              data: response?.data?.Response,
              OTPRequired: OTPRequired,
              forcePassword: forcePassword,
            },
          });
          //both false
          //unlockAccount(response?.data?.Response);
          //console.log('...working', response?.data?.Response);
        }
      }

      //setOTPRequired(response?.data?.Response?.OtpRequired);
      //setForcePassword(response?.data?.Response?.ResetPassword);
    } catch (e) {
      setServerError(true);
      console.log(e);
    }
  };

  const setToken = (data) => {
    const bearerToken =
      'Bearer ' +
      data?.LoginResponse?.access_token +
      ',' +
      data?.LoginResponse?.refresh_token;
    console.log('...data', bearerToken);
    dispatch(setBearerToken(bearerToken));
  };

  useEffect(() => {
    console.log('...slug', slug);
    verifyLink();
  }, []);

  useEffect(() => {
    if (headingRef.current) {
      headingRef.current.focus();
    }
  }, [isLoading, serverError]);
  return { isLoading, serverError, OTPRequired, forcePassword, headingRef };
};

export default useAccountUnlockVerifyLink;
